import React from 'react';
import {
  useSocketConfig,
  stoneByOtherId,
  stoneImageUrl,
  stoneDisplayName,
  effectLabel,
  computeSocketBonuses,
  isEnglish,
} from '../../utils/socketConfig';
import './Sockets.css';

// Taşın soketteki parıltı rengi.
const GLOW = {
  red: '#ff3b4e', crimson: '#d01040', blue: '#3b8bff', green: '#2ee07a', lime: '#7be04a', yellow: '#ffd23b',
  amber: '#ffb02e', purple: '#b45bff', white: '#dff4ff', orange: '#ff8a2b', fire: '#ff5a1a', teal: '#2fd6c8', steel: '#8fb3d9',
};

// Eşya üzerindeki soketleri (dolu/boş), taş bonuslarını ve aktif kombinasyonları gösterir.
const SocketSlots = ({ item, compact = false, selectedIndex = null, onSelectSocket = null }) => {
  const cfg = useSocketConfig();
  const count = item?.socketCount || 0;
  if (!count) return null;
  const slots = Array.from({ length: count }, (_, i) => item?.sockets?.[i] || 0);
  const en = isEnglish();
  const { rows, combos } = cfg ? computeSocketBonuses(cfg, slots) : { rows: [], combos: [] };

  return (
    <div className={`socket-box${compact ? ' socket-box--compact' : ''}`}>
      <div className="socket-box-title">
        <span className="socket-box-orn">◆</span> {en ? 'Sockets' : 'Soketler'} <span className="socket-box-count">{slots.filter(Boolean).length}/{count}</span> <span className="socket-box-orn">◆</span>
      </div>
      <div className="socket-row">
        {slots.map((id, i) => {
          const found = stoneByOtherId(cfg, id);
          const clickable = !!onSelectSocket && !id;
          return (
            <button
              key={i}
              type="button"
              className={`socket-hole${found ? ' socket-hole--filled' : ''}${id < 0 ? ' socket-hole--broken' : ''}${found?.stone.kind === 'rune' ? ' socket-hole--rune' : ''}${selectedIndex === i ? ' socket-hole--selected' : ''}`}
              style={found ? { '--socket-glow': GLOW[found.stone.color] || '#c9a2ff' } : undefined}
              onClick={clickable ? () => onSelectSocket(i) : undefined}
              disabled={!clickable}
              title={found ? stoneDisplayName(cfg, found.stone, found.level) : id < 0 ? (en ? 'Broken stone (no effect)' : 'Kırık taş (etkisiz)') : en ? 'Empty socket' : 'Boş soket'}
            >
              {found ? <img src={stoneImageUrl(found.stone, found.level)} alt="" /> : null}
              {id < 0 ? <img src={`${process.env.PUBLIC_URL || ''}/image/others/gems/kirik.png`} alt="" /> : null}
            </button>
          );
        })}
      </div>
      {!compact && slots.some((x) => x < 0) ? (
        <p className="socket-bonus-row socket-broken-note">
          💔 {en ? 'Broken stones have no effect; clear them with a Stone Cleaning Kit.' : 'Kırık taşların etkisi yok; Taş Temizleme Kiti ile temizlenir.'}
        </p>
      ) : null}
      {!compact && rows.map((r, i) => (
        <p key={`sr-${i}`} className="socket-bonus-row">
          {effectLabel(cfg, r.effect)}: <span className="socket-bonus-val">+{r.value}</span>
        </p>
      ))}
      {combos.map((c) => (
        <div key={c.key} className="socket-combo">
          <strong>✨ {en ? c.nameEn : c.name}</strong>
          {!compact && (
            <span>
              {c.bonuses.map((b) => `${effectLabel(cfg, b.type)} +${b.value}`).join(' · ')}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default SocketSlots;
